import StudentCourseDetail from '../../features/student/StudentCourseDetail'

const StudentCourseDetailPage = () => {
  return <StudentCourseDetail/>
}

export default StudentCourseDetailPage